/* EZMA OUD - Product Card Ratings
   Loaded on every page so ratings appear on collection grids, featured products, homepage.
      Counts synced with Judge.me widget totals (custom.rating_count metafields). Last sync: 2026-07-16 */
      var PRODUCT_STATS = {
      "bakhoor-al-rawdah-ezma-oud":{total:1608,avg:4.94},
      "bakhoor-ward-alsultan-ezma-oud":{total:1008,avg:4.95},
      "bakhoor-tayba-blue-ezma-oud":{total:820,avg:4.93},
      "bakhoor-tayba-black-ezma-oud":{total:1099,avg:4.93},
      "bakhoor-al-rawdah-crimson-ezma-oud":{total:818,avg:4.94},
      "bakhoor-al-rawdah-violet-ezma-oud":{total:899,avg:4.93},
      "bakhoor-al-rawdah-silver-ezma-oud":{total:921,avg:4.93},
      "bakhoor-alrawdah-harami-ezma-oud":{total:644,avg:4.95},
      "bakhoor-tayba-harami-ezma-oud":{total:678,avg:4.96},
      "bakhoor-alrawdah-crimson-harami-ezma-oud":{total:848,avg:4.95},
      "bakhoor-alrawdah-silver-harami-ezma-oud":{total:701,avg:4.92},
      "bakhoor-alrawdah-violet-harami-ezma-oud":{total:862,avg:4.92},
      "bakhoor-dylaa-harami-ezma-oud":{total:795,avg:4.96},
      "bakhoor-kayan-harami-ezma-oud":{total:769,avg:4.95},
      "ezma-al-rawdah-eau-de-parfum-100ml":{total:730,avg:4.95},
      "ezma-tayba-eau-de-parfum-100-ml":{total:653,avg:4.95},
      "ezma-tayba-eau-de-parfum-30ml":{total:566,avg:4.95},
      "ezma-al-rawdah-eau-de-parfum-30ml":{total:759,avg:4.94},
      "ezma-best-sellers-duo-bakhoor-set-al-rawdah-tayba-blue":{total:225,avg:4.92},
      "royal-rose-duo-bakhoor-set-ward-alsultan-rawdah-violet":{total:225,avg:4.98},
      "discovery-trio-bakhoor-set-al-rawdah-tayba-blue-crimson":{total:225,avg:4.96},
      "no-charcoal-home-set-harami-cones-alrawdah-kayan":{total:225,avg:5},
      "harami-family-set-4-boxes-of-cones-alrawdah-tayba-dylaa-kayan":{total:225,avg:5},
      "scent-twin-set-bakhoor-al-rawdah-35g-al-rawdah-edp-30ml":{total:226,avg:4.96},
      "perfume-duo-al-rawdah-edp-100ml-tayba-edp-30ml":{total:225,avg:5},
      "ezma-two-ways-set-bakhoor-jar-harami-cones-pick-your-scent":{total:225,avg:4.96},
      "day-night-duo-bakhoor-set-tayba-blue-tayba-black":{total:224,avg:4.95},
      "no-charcoal-home-set-harami-cones-kayan-dylaa":{total:0,avg:5}
      };
      (function(){"use strict";window.buildStars=function(avg){for(var full=Math.floor(avg),half=avg-full>=.5?1:0,empty=5-full-half,html="",i=0;i<full;i++)html+='<span class="pc-star pc-star--full">&#9733;</span>';half&&(html+='<span class="pc-star pc-star--half">&#9733;</span>');for(var i=0;i<empty;i++)html+='<span class="pc-star pc-star--empty">&#9733;</span>';return html};function formatCount(n){return!n||n===0?"":n>=1e3?"("+(n/1e3).toFixed(1).replace(/\.0$/,"")+"k)":"("+n+")"}function updateAll(){document.querySelectorAll(".product-card__rating[data-handle]").forEach(function(ratingEl){var handle=ratingEl.dataset.handle,stats=PRODUCT_STATS[handle]||{avg:5,total:0},starsEl=ratingEl.querySelector(".product-card__stars"),valEl=ratingEl.querySelector(".product-card__rating-value"),cntEl=ratingEl.querySelector(".product-card__rating-count");starsEl&&(starsEl.innerHTML=buildStars(stats.avg)),valEl&&(valEl.textContent=parseFloat(stats.avg).toFixed(1)),cntEl&&(cntEl.textContent=formatCount(stats.total))})}document.readyState==="loading"?document.addEventListener("DOMContentLoaded",updateAll):updateAll(),document.addEventListener("shopify:section:load",updateAll),document.addEventListener("shopify:section:select",updateAll),document.addEventListener("reviews:loaded",updateAll)})();/* ──────────────────────────────────────────────
  EZMA OUD — Product Card Ratings
  Lightweight script loaded on EVERY page so ratings appear
  on collection grids, featured-products, homepage, etc.
  Counts synced with Judge.me widget totals (custom.rating_count)
  Last sync: 2026-07-16
────────────────────────────────────────────── */

var PRODUCT_STATS = {
  "bakhoor-al-rawdah-ezma-oud":                                    {total:1608, avg:4.94},
  "bakhoor-ward-alsultan-ezma-oud":                                {total:1008, avg:4.95},
  "bakhoor-tayba-blue-ezma-oud":                                   {total:820,  avg:4.93},
  "bakhoor-tayba-black-ezma-oud":                                  {total:1099, avg:4.93},
  "bakhoor-al-rawdah-crimson-ezma-oud":                            {total:818,  avg:4.94},
  "bakhoor-al-rawdah-violet-ezma-oud":                             {total:899,  avg:4.93},
  "bakhoor-al-rawdah-silver-ezma-oud":                             {total:921,  avg:4.93},
  "bakhoor-alrawdah-harami-ezma-oud":                              {total:644,  avg:4.95},
  "bakhoor-tayba-harami-ezma-oud":                                 {total:678,  avg:4.96},
  "bakhoor-alrawdah-crimson-harami-ezma-oud":                      {total:848,  avg:4.95},
  "bakhoor-alrawdah-silver-harami-ezma-oud":                       {total:701,  avg:4.92},
  "bakhoor-alrawdah-violet-harami-ezma-oud":                       {total:862,  avg:4.92},
  "bakhoor-dylaa-harami-ezma-oud":                                 {total:795,  avg:4.96},
  "bakhoor-kayan-harami-ezma-oud":                                 {total:769,  avg:4.95},
  "ezma-al-rawdah-eau-de-parfum-100ml":                            {total:730,  avg:4.95},
  "ezma-tayba-eau-de-parfum-100-ml":                               {total:653,  avg:4.95},
  "ezma-tayba-eau-de-parfum-30ml":                                 {total:566,  avg:4.95},
  "ezma-al-rawdah-eau-de-parfum-30ml":                             {total:759,  avg:4.94},
  "ezma-best-sellers-duo-bakhoor-set-al-rawdah-tayba-blue":        {total:225,  avg:4.92},
  "royal-rose-duo-bakhoor-set-ward-alsultan-rawdah-violet":        {total:225,  avg:4.98},
  "discovery-trio-bakhoor-set-al-rawdah-tayba-blue-crimson":       {total:225,  avg:4.96},
  "no-charcoal-home-set-harami-cones-alrawdah-kayan":              {total:225,  avg:5},
  "harami-family-set-4-boxes-of-cones-alrawdah-tayba-dylaa-kayan": {total:225,  avg:5},
  "scent-twin-set-bakhoor-al-rawdah-35g-al-rawdah-edp-30ml":       {total:226,  avg:4.96},
  "perfume-duo-al-rawdah-edp-100ml-tayba-edp-30ml":                {total:225,  avg:5},
  "ezma-two-ways-set-bakhoor-jar-harami-cones-pick-your-scent":    {total:225,  avg:4.96},
  "day-night-duo-bakhoor-set-tayba-blue-tayba-black":              {total:224,  avg:4.95},
  "no-charcoal-home-set-harami-cones-kayan-dylaa":                 {total:0,    avg:5}
};

(function () {
  'use strict';

  window.buildStars = function (avg) {
    var full  = Math.floor(avg);
    var half  = (avg - full) >= 0.5 ? 1 : 0;
    var empty = 5 - full - half;
    var html  = '';
    for (var i = 0; i < full;  i++) html += '<span class="pc-star pc-star--full">&#9733;</span>';
    if (half)                       html += '<span class="pc-star pc-star--half">&#9733;</span>';
    for (var j = 0; j < empty; j++) html += '<span class="pc-star pc-star--empty">&#9733;</span>';
    return html;
  }

  function formatCount(n) {
    if (!n || n === 0) return '';
    if (n >= 1000) return '(' + (n / 1000).toFixed(1).replace(/\.0$/, '') + 'k)';
    return '(' + n + ')';
  }

  function updateAll() {
    document.querySelectorAll('.product-card__rating[data-handle]').forEach(function (ratingEl) {
      var handle  = ratingEl.dataset.handle;
      var stats   = PRODUCT_STATS[handle] || { avg: 5, total: 0 };
      var starsEl = ratingEl.querySelector('.product-card__stars');
      var valEl   = ratingEl.querySelector('.product-card__rating-value');
      var cntEl   = ratingEl.querySelector('.product-card__rating-count');
      if (starsEl) starsEl.innerHTML = buildStars(stats.avg);
      if (valEl)   valEl.textContent = parseFloat(stats.avg).toFixed(1);
      if (cntEl)   cntEl.textContent = formatCount(stats.total);
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', updateAll)
    : updateAll();
  document.addEventListener('shopify:section:load', updateAll);
  document.addEventListener('shopify:section:select', updateAll);
  document.addEventListener('reviews:loaded', updateAll);
})();